import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import Close from "../../Components/Icons/Close";
import cssClasses from "./PreselectConfirmation.module.css";
import { makeStyles } from "@mui/styles";
import Button from "../../Subcomponents/Button";
import {
	CancelPreselectConfirmation,
	submitPreselectConfirmation,
	getBookingAmountsByProjectId,
	getPaymentPlansPriceFromServer,
} from "../../Services/Allotment";
import { errorTost, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { Cancel } from "@mui/icons-material";
import PreselectCalenderIcon from "../../Assets/Images/Common/AllotmentCalender.svg";
import { sendMailTo } from "../../Services/SmsService";
import { useSelector } from "react-redux";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
import DiscountImg from "../../Assets/Images/Common/disountImg.PNG";

const useStyles = makeStyles((theme) => ({
	tokenName: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "2rem",
		lineHeight: "3rem",
		color: "#000000",
	},
	wrapperIcons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-around",
		marginBottom: "2rem",
		position: "relative",
	},
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.7rem",
		top: "1.7rem",
	},
	title: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2.8rem",
		color: "#101828",
		marginBottom: "0.8rem",
	},
	subTitle: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelCard: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelValue: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	wrapperButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		columnGap: "1.2rem",
	},
	backArrow: {
		verticalAlign: "middle",
	},
}));
const PreselectConfirmation = ({ open, handleClose, allotmentDetails, returnResp = () => { } }) => {
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	const [bookingUnitCost, setBookingUnitCost] = useState();
	const classes = useStyles();
	const [updatedUnitCost, setUpdatedUnitCost] = useState({
		bsp: "",
		gst: "",
		sdr: "",
		total: "",
	});
	const [loading, setLoading] = useState(false);
	function closeModal() {
		handleClose();
	}
	useEffect(() => {
		if (allotmentDetails?.unitId) {
			presentLoader();
			getBookingAmountsByProjectId(
				allotmentDetails?.unitId?.projectId?.projectId,
				allotmentDetails?.unitId?.inventoryTypeId?.inventoryTypeId,
				allotmentDetails?.unitId?.wingId?.wingId
			)
				.then((val) => {
					setBookingUnitCost(val?.data[0]);
					dismissLoader();
				})
				.catch((err) => {
					dismissLoader();
					console.log(err.message);
				});
		}
		if (allotmentDetails?.paymentPlanId) {
			getPaymentPlansPriceFromServer(allotmentDetails?.paymentPlanId, allotmentDetails?.unitId?.unitId)
				.then((planResp) => {
					if (planResp?.data[0]) {
						setUpdatedUnitCost({
							bsp: planResp?.data[0]?.BSP,
							gst: planResp?.data[0]?.GST,
							sdr: planResp?.data[0]?.SDR,
							total: planResp?.data[0]?.totalCost,
						});
					} else {
						setUpdatedUnitCost({
							bsp: allotmentDetails?.unitId?.BSP,
							gst: allotmentDetails?.unitId?.GST,
							sdr: allotmentDetails?.unitId?.SDR,
							total: allotmentDetails?.unitId?.totalCost,
						});
					}
				})
				.catch((err) => {
					setUpdatedUnitCost({
						bsp: allotmentDetails?.unitId?.BSP,
						gst: allotmentDetails?.unitId?.GST,
						sdr: allotmentDetails?.unitId?.SDR,
						total: allotmentDetails?.unitId?.totalCost,
					});
					errorTost("Error While getting Payment Plan Details.");
					console.log(err.message);
				});
		} else {
			setUpdatedUnitCost({
				bsp: allotmentDetails?.unitId?.BSP,
				gst: allotmentDetails?.unitId?.GST,
				sdr: allotmentDetails?.unitId?.SDR,
				total: allotmentDetails?.unitId?.totalCost,
			});
		}
	}, [allotmentDetails]);

	// useEffect(() => {
	// 	let bsp = 0;
	// 	let gst = 0;
	// 	let sdr = 0;
	// 	let total = 0;
	// 	if (allotmentDetails?.discountPercentage !== 0) {
	// 		if (allotmentDetails?.unitCost?.bsp !== 0) {
	// 			total = allotmentDetails?.unitCost?.total - (allotmentDetails?.unitCost?.total * allotmentDetails?.discountPercentage) / 100;
	// 			bsp = (total - 45000) / 1.12;
	// 			gst = bsp * 0.05;
	// 			sdr = bsp * 0.07 + 45000;
	// 		} else {
	// 			total =
	// 				allotmentDetails?.unitId?.totalCost === 0
	// 					? 0
	// 					: allotmentDetails?.unitId?.totalCost - (allotmentDetails?.unitId?.totalCost * allotmentDetails?.discountPercentage) / 100;
	// 			bsp = allotmentDetails?.unitId?.BSP === 0 ? 0 : (total - 45000) / 1.12;
	// 			gst = allotmentDetails?.unitId?.GST === 0 ? 0 : bsp * 0.05;
	// 			sdr = allotmentDetails?.unitId?.SDR === 0 ? 0 : bsp * 0.07 + 45000;
	// 		}
	// 	} else {
	// 		bsp = allotmentDetails?.unitId?.BSP === 0 ? 0 : allotmentDetails?.unitId?.BSP;
	// 		gst = allotmentDetails?.unitId?.GST === 0 ? 0 : allotmentDetails?.unitId?.GST;
	// 		sdr = allotmentDetails?.unitId?.SDR === 0 ? 0 : allotmentDetails?.unitId?.SDR;
	// 		total = allotmentDetails?.unitId?.totalCost === 0 ? 0 : allotmentDetails?.unitId?.totalCost;
	// 	}

	// 	setUpdatedUnitCost((pre) => {
	// 		pre.bsp = Math.round(bsp);
	// 		pre.gst = Math.round(gst);
	// 		pre.sdr = Math.round(sdr);
	// 		pre.total = Math.round(total);

	// 		return { ...pre };
	// 	});
	// }, [allotmentDetails]);

	function sendMail(email, subject, message) {
		let body = {
			to: [email],
			subject: subject,
			message: message,
		};
		sendMailTo(body)
			.then((resp) => { })
			.catch((err) => {
				console.log(err);
			});
	}

	function submitConfirmation(selectedAllotment) {
		presentLoader();

		selectedAllotment.preselectConfirmation = "confirmed";
		// submitPreselectConfirmation(selectedAllotment, updatedUnitCost,bookingUnitCost).then((resp) => {
		const unitCost = {
			bsp: allotmentDetails.unitId?.BSP,
			gst: allotmentDetails.unitId?.GST,
			sdr: allotmentDetails.unitId?.SDR,
			total: allotmentDetails.unitId?.totalCost,
		};
		let isDiscountEligible = allotmentDetails?.discountPercentage > 0 ? true : false;
		submitPreselectConfirmation(selectedAllotment, updatedUnitCost, bookingUnitCost, isDiscountEligible)
			.then((resp) => {
				setLoading(false);
				let message = `<p>Congratulations! Your request for this unit has been approved, We are pleased to confirm your preselected unit in ${allotmentDetails?.unitId?.projectId?.projectName}, ${allotmentDetails?.unitId?.wingId?.wingName}, on the ${allotmentDetails?.unitId?.floorNo}, Unit ${allotmentDetails?.unitId?.unitNo}</p></br>`;
				if (resp.success) {
					successTost(
						`Confirmation for ${selectedAllotment.unitId.wingId.displayName
							? selectedAllotment.unitId.wingId.displayName
							: selectedAllotment.unitId.wingId.wingName
						} - ${selectedAllotment.unitId.unitNo} submitted successfully!`
					);
					sendMail(
						loggedInUser?.personId?.email,
						`${allotmentDetails?.discountPercentage !== 0 ? "Preselect Booking Confirmation" : "Preselect Booking Confirmation"}`,
						message
					);
					returnResp(true);
					closeModal();
				} else {
					errorTost("Error in submitting confirmation!");
					returnResp(false);
					closeModal();
				}
				dismissLoader();
			})
			.catch(() => {
				setLoading(false);
				errorTost("Error in submitting confirmation!");
				returnResp(false);
				dismissLoader();
				closeModal();
			});
	}

	function CancelConfirmation(selectedAllotment) {
		presentLoader();
		selectedAllotment.preselectConfirmation = "not confirmed";
		CancelPreselectConfirmation(selectedAllotment)
			.then((resp) => {
				if (resp.data.message === "success") {
					successTost(
						`Confirmation for ${selectedAllotment.unitId.wingId.displayName
							? selectedAllotment.unitId.wingId.displayName
							: selectedAllotment.unitId.wingId.wingName
						} - ${selectedAllotment.unitId.unitNo} submitted successfully!`
					);
					returnResp(false);
					closeModal();
				} else {
					errorTost("Error in cancelling confirmation!");
					returnResp(false);
					closeModal();
				}
				dismissLoader();
			})
			.catch((err) => {
				errorTost("Error in cancelling confirmation!");
				returnResp(false);
				dismissLoader();
				closeModal();
			});
	}
	function numDifferentiation(value) {
		const val = Math.abs(value);
		if (val >= 10000000) return `${(value / 10000000).toFixed(2)} Crore`;
		if (val >= 100000) return `${(value / 100000).toFixed(2)} Lakh`;
		return value;
	}
	function arrayContains(key, arr) {
		if (arr?.length > 0) {
			return arr.indexOf(key) > -1;
		} else {
			return false;
		}
	}
	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					handleClose();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div>Pre-select confirmation</div>
				</div>
				<div className={cssClasses.wrapperContent}>
					<div className={cssClasses.cardHeader}>
						<div className={cssClasses.cardDetails}>
							<div className={cssClasses.tokenDetails}>
								<div className={cssClasses.tokenNumWrap}>
									<span>
										{allotmentDetails.unitId?.wingId?.displayName
											? allotmentDetails.unitId?.wingId?.displayName
											: allotmentDetails.unitId?.wingId?.wingName}{" "}
										- {allotmentDetails.unitId?.unitNo}{" "}
									</span>

									<span className={cssClasses.tokenProjectName}>{allotmentDetails.unitId?.projectId?.projectName}</span>
								</div>
								{/* {allotmentDetails.paymentId && (
									<div className={cssClasses.tokenData}>
										<span>{allotmentDetails.paymentId?.eventTokenId?.eventId?.title}</span>
									</div>
								)} */}
								<div className={cssClasses.preselectUnitData}>
									<span>{allotmentDetails.unitId?.inventoryTypeId?.type}</span>
									<span>{" • "}</span>
									<span>{allotmentDetails.unitId?.floorNo}</span>
									<span>{" • "}</span>
									<span>
										{allotmentDetails.paymentId?.eventId?.title || allotmentDetails.paymentId?.eventTokenId?.eventId?.title}
									</span>
									<span>{" • "}</span>
									<span>{allotmentDetails.paymentId?.tokenNumber}</span>
								</div>
								<div className={cssClasses.allotmentDate}>
									<div className={cssClasses.allotmentDateData}>
										<img src={PreselectCalenderIcon} alt="Calender-check" />
										Alloted On:
									</div>
									<div className={cssClasses.preselectDate}>
										{new Date(allotmentDetails.created_at).toDateString()},{" "}
										{new Date(allotmentDetails.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
									</div>
								</div>
								<div className={cssClasses.tokenData1}>
									{arrayContains("BSP", allotmentDetails?.showPreselectPrices) && (
										<div>
											<span>Agreement Value :</span>
											<span>₹ {numberWithCommas(updatedUnitCost?.bsp)}</span>
										</div>
									)}
									{arrayContains("GST", allotmentDetails?.showPreselectPrices) && (
										<div>
											<span>GST:</span>
											<span>₹ {numberWithCommas(updatedUnitCost?.gst)}</span>
										</div>
									)}
									{arrayContains("SDR", allotmentDetails?.showPreselectPrices) && (
										<div>
											<span>SDR:</span>
											<span>₹ {numberWithCommas(updatedUnitCost?.sdr)}</span>
										</div>
									)}
									{/* <div>
                    <span>Total:</span>
                    <span>
                      
                      ₹ {numberWithCommas(allotmentDetails.unitCost?.total)}
                    </span>
                  </div> */}
								</div>
							</div>
						</div>
						<div className={cssClasses.cardFooter}>
							{/* <div className={cssClasses.totalAmt}>
                <span>Total Amount : </span>
                <span>
                  ₹{' '}
                  {numberWithCommas(
                    allotmentDetails.paymentId?.eventTokenId?.tokenId?.amount
                  )}
                </span>
              </div> */}
							{/* <div className={cssClasses.paidAmt}>
                <span>Paid Amount : </span>
                <span>₹ {numberWithCommas(allotmentDetails.paidAmount)}</span>
              </div> */}
							<div className={cssClasses.amtBtnData}>
								<div className={cssClasses.totalAmt}>
									<div>Total Cost (CLP) : </div>
									<div className={cssClasses.amtText}>₹ {numberWithCommas(updatedUnitCost?.total)} </div>
								       <div
										style={{
											fontSize: "8px",
											display: "flex",
											justifyContent: "flex-start",
											alignItems: "flex-start",
											width: "100%"
										}}
										>
										CLP = Construction Link Payment Plan.
										</div>
								</div>
							</div>

						</div>
						<div>
							{(allotmentDetails?.eventId === "3ee672b5-e700-4eb6-be77-d1b6b0516015" || allotmentDetails?.eventId === "b0fa00c7-e2da-4695-8e88-111e7b28a812") && (
								<div style={{ padding: "1rem", textAlign: "left", width: "95%", backgroundColor: "#efa04cff"  }}>
									<div style={{ fontWeight: "bold", fontSize: "1.4rem"  }}>CONFIRM Now, Decide Later! </div>
									<div style={{ fontSize: "1.4rem" }}>For No Pre-EMI price, please refer detailed pricelist. Offer applicable only to PreSelect units.</div>
								</div>
							)}
							</div>
							{/* {allotmentDetails?.eventId === "6e4e8aad-72fd-4e95-b6cf-48cc69c9005a" && allotmentDetails?.launchId === "c28e61d4-4c45-4369-bd5d-adfa289ef443" &&
							<div className={cssClasses.imageContainer}>
								<img src={DiscountImg} alt="Discount image" />
							</div>
						} */}
							<div className={cssClasses.wrapperFooter}>
								<div>
									<Button
										style={{
											color: "#344054",
											backgroundColor: "#ffffff",
											fontSize: "1.6rem",
											lineHeight: "2.4rem",
											borderRadius: "8px",
											border: "1px solid var(--gray-300, #D0D5DD)",
											boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
										}}
										btnName={"No"}
										clicked={() => {
											CancelConfirmation(allotmentDetails);
										}}
									/>
								</div>
								<div>
									<Button
										style={{
											color: "#ffffff",
											backgroundColor: "#155EEF",
											fontSize: "1.6rem",
											lineHeight: "2.4rem",
										}}
										// disable={!enableBtn}
										isLoading={loading}
										btnName={"Yes"}
										clicked={() => {
											setLoading(true);
											submitConfirmation(allotmentDetails);
										}}
									//   disable={disabeNext}
									/>
								</div>
							</div>
						{/* <div className={cssClasses.confirmBtnWrap}> */}
						{/* {allotment.expiry > Date.now() && ( */}
						{/* <> */}
						{/* <div>
                                    <Button btnName={"Confirm"}
                                        clicked={() => {
                                            setAllotment(allotment);
                                            setOpenConfirmationModal(true);
                                        }
                                        }
                                        style={{
                                            width: "20%",
                                            color: "#fff",
                                            backgroundColor: "rgb(21, 112, 239)",
                                            fontSize: "1.4rem",
                                            lineHeight: "2rem",
                                            fontFamily: "Inter-Medium !important",
                                        }}>

                                    </Button>
                                </div>
                                <div className={cssClasses.timerWrap}>
                                    Expires in <MyTimer css={{ fontSize: "1.8rem", color: "#98A2B3" }} expiryTimestamp={allotment.expiry} />
                                </div> */}
						{/* </> */}
						{/* )} */}
						{/* </div> */}
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default PreselectConfirmation;